/**
 * PlatformSLSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PlatformSLSiteHeaderLanguages
 */

import { usePlatformSLSiteHeaderLanguagesLogic } from '@/hooks/traits/usePlatformSLSiteHeaderLanguagesLogic';
import type { PlatformSLSiteHeaderLanguagesConfig } from '@/hooks/traits/usePlatformSLSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PlatformSLPlatformView as PlatformSLPlatformViewEntity } from '@app/shared';
import { Menu } from '@almadar/ui/components';
import { Button } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface PlatformSLSiteHeaderLanguagesViewProps {
  config?: Partial<PlatformSLSiteHeaderLanguagesConfig>;
}

export function PlatformSLSiteHeaderLanguagesView({ config: propsConfig }: PlatformSLSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePlatformSLSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PlatformSLPlatformView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PlatformSL" trait="PlatformSLSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu className={((([{ href: "/platform" as const, label: "English" as const, code: "en" as const }, { label: "العربية" as const, code: "ar" as const, href: "/ar/platform" as const }, { href: "/sl/platform" as const, code: "sl" as const, label: "Slovenščina" as const }]).length === 0)) ? "hidden" : ""} items={Array.isArray(([{ href: "/platform" as const, label: "English" as const, code: "en" as const }, { href: "/ar/platform" as const, label: "العربية" as const, code: "ar" as const }, { code: "sl" as const, href: "/sl/platform" as const, label: "Slovenščina" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), href: (getNestedValue(entry, "href") ?? ""), id: (getNestedValue(entry, "code") ?? "") }))) ? (((([{ href: "/platform" as const, label: "English" as const, code: "en" as const }, { href: "/ar/platform" as const, label: "العربية" as const, code: "ar" as const }, { code: "sl" as const, href: "/sl/platform" as const, label: "Slovenščina" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), href: (getNestedValue(entry, "href") ?? ""), id: (getNestedValue(entry, "code") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} position="bottom-end" trigger={<Button icon="globe" label={String(__locale.toUpperCase())} size="sm" variant="ghost" />} />) : null}
    </TraitScopeProvider>
  );
}

export default PlatformSLSiteHeaderLanguagesView;
